import React from 'react';
import AccountDesktop from '../../assets/icons/account_desktop.svg';
import AccountMobile from '../../assets/icons/account_mobile.svg';
import { useTranslation } from 'react-i18next';

const AccountButton =  React.memo(({ url, text }) => {
  const { t } = useTranslation();

  return (
    <a href={url} className="account-button" aria-label={t('navigation.my_digid')} title={text}>
      <AccountDesktop />
      <AccountMobile />
      <span>{text}</span>
    </a>
  );
});

AccountButton.defaultProps = {
  url: '/account',
  text: 'Account',
};

export default AccountButton;
